import React from 'react';
import Styles from './Checkbox.css';
import clsx from 'clsx';

function Checkbox({ checked = false, handleChange, label, id, variant = 'checkbox', className }) {
  const checkedImg =
    variant === 'radio'
      ? 'assets/simulador-energia-solar/jornada/ic-radio-on.svg'
      : 'assets/shared/ic-check.svg';

  return (
    <>
      <div
        className={clsx(
          {
            'checkbox-component': true,
            checked,
            [variant]: true,
          },
          className,
        )}
        id={id}
      >
        <div className="chk-container">
          <div className="checkbox">
            <div className="custom-style" aria-hidden="true">
              {checked && <img src={checkedImg} alt="" />}
            </div>

            <input
              type="checkbox"
              checked={checked}
              onChange={(ev) => {
                if (handleChange) {
                  handleChange(ev.target.checked);
                }
              }}
            />
          </div>

          {label && <p className="label">{label}</p>}
        </div>
      </div>
      <style jsx>{Styles}</style>
    </>
  );
}

export default Checkbox;
